import React from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { AlertTriangle } from "lucide-react"
import { useTranslation } from "react-i18next"
const UnAuthorized = () => {
  const { t } = useTranslation()
  return (
    <Container fluid className="page-content">
      <Row>
        <Col md={{ size: 6, offset: 3 }}>
          <Card className="text-center shadow-lg border-0 mt-5">
            <CardBody>
              <AlertTriangle size={60} className="text-danger mb-3" />
              <h2 className="text-danger">({"Access Denied"})</h2>
              <p className="text-muted">
                {t("You do not have permission to view this page.")}
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default UnAuthorized
